import React, { Component } from 'react';
import { Spin } from 'antd';

export default class Loding extends Component {
    render() {
        return (
            <div className="loading_box" style={{ display: this.props.isLoading ? 'block' : 'none' }}>
                <div className="loading">
                    <Spin tip="数据正在加载中, 请耐心等候..." />
                </div>
            </div> 
        );
    }
}   